const initialState = {
  businesses: [],
  mainBusiness: null
};

const useUpdatedInfo = function(business) {
  if (business.requestUpdateInfo)
    return Object.assign({}, business, business.requestUpdateInfo);
  else {
    return business;
  }
}

function myBusinesses(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_MY_BUSINESS_LIST":
      return {
        businesses: action.businesses,
        mainBusiness: useUpdatedInfo(action.mainBusiness) || null
      };
    case "UPDATE_BUSINESS_INFO": {
      let newBusinessState = [];

      state.businesses && state.businesses.map(business => {
        if (business.id == action.data.id) {
          newBusinessState.push(action.data);
        } else {
          newBusinessState.push(business);
        }
      });

      return {
        businesses: newBusinessState,
        mainBusiness: useUpdatedInfo(action.data)
      };
    }

    case "UPDATE_MAIN_BUSINESS":
      return {
        ...state,
        mainBusiness: useUpdatedInfo(action.business)
      }
    case "LOGOUT":
      return {
        businesses: null,
        mainBusiness: null
      };
    default:
      return state;
  }
}

export {myBusinesses};



// WEBPACK FOOTER //
// ./reducers/my-businesses.js